/* eslint-disable @nx/enforce-module-boundaries */
import { useState } from 'react';
import { VerticalThreeDot } from '@mybridge/icons';
import { Avatar, Box, HStack, IconButton, Stack, Text } from '@mybridge/ui';
import { useDimensions } from '@mybridge/ui/hooks';
import { forwardRef, useContext, useRef } from 'react';
import { getUserFullName, getUserProfilePic } from 'v4/lib/commons';
import { DiskContext } from '../../context';
import { SharedDiskUserItemMenu } from '../listing-item-menu';
import { DiskNoFilesIllustration } from '../../no-files-illustration';
import { isMobile } from 'react-device-detect';
export const SharedDiskUsersListingGrid = forwardRef(
  ({ menu, ...props }, ref) => {
    const {
      files,
      filesLoading,
      setSelectedDir,
      selectedFile,
      setSelectedFile,
      selectSharedDiskUser,
    } = useContext(DiskContext);
    const [clickCount, setClickCount] = useState(0);
    const tableParentRef = useRef();
    const tabelParentSize = useDimensions(tableParentRef, true)?.borderBox;
    const { width = 640, height = 480 } = tabelParentSize ?? {};

    const onFileSelect = (file) => {
      setSelectedFile(file);
    };

    const handleMobileClick = (file) => {
      setClickCount((prevCount) => prevCount + 1);
  
      if (clickCount === 1) {
        // This is the second click (double click)
        handleDoubleClick(file);
      } else {
        onFileSelect(file)
      }
  
      // Reset click count after a short delay
      setTimeout(() => setClickCount(0), 300);
    };

    const handleDoubleClick = (file) => {
      // Handle double click action
      selectSharedDiskUser(file);
    };

    const isFolder = (file) => file?.type === 'D' || file?.type === 'RD';
    return (
      <>
        <Stack
          minH="60vh"
          ref={tableParentRef}
          display={['flex', 'flex', 'flex']}
        >
          {/* grid view */}
          {files?.length ? (
            <HStack spacing={0} gap={2} flexWrap="wrap" w="100%">
              {files?.map?.((file, findex) => (
                <Stack
                  _hover={{
                    bg: 'brandGray.500',
                  }}
                  p={4}
                  w={['49%', '49%', '19.35%']}
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="5"
                  cursor="pointer"
                  bg={selectedFile?.id === file?.id ? 'brandGray.500' : ''}
                  onClick={(e) => {isMobile ? handleMobileClick(file) : onFileSelect(file)}}
                  onDoubleClick={(e) => selectSharedDiskUser(file)}
                  userSelect="none"
                  pos="relative"
                  key={findex}
                >
                  {menu ?? (
                    <Box pos="absolute" right="2" top="2">
                      <SharedDiskUserItemMenu>
                        <IconButton variant="ghost">
                          <VerticalThreeDot width="16" height="16" />
                        </IconButton>
                      </SharedDiskUserItemMenu>
                    </Box>
                  )}

                  <Avatar
                    size="lg"
                    src={getUserProfilePic(file)}
                    name={getUserFullName(file)}
                  />
                  <Text
                    textAlign="center"
                    title={file?.name}
                    w="150px"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                  >
                    {getUserFullName(file)}
                  </Text>
                </Stack>
              ))}
            </HStack>
          ) : (
            <DiskNoFilesIllustration loading={filesLoading} />
          )}
        </Stack>
        <Stack display={['flex', 'flex', 'none']}>{/* list view */}</Stack>
      </>
    );
  }
);
